<template>
  <div>
    <FilterOption @option="onOptionChange"/>

    <Activitys @info="yourself" :caption="$t('assessment')" :item="item" @reload="onLoad"/>

    <div v-if="this.isAssessment">
      <CRow>
        <CCol>
          <CometencyParent :objs="objs"/>
        </CCol>
      </CRow>

      <CRow class="mb-4">
        <CCol class="text-right">
          <CButton v-if="buttomControl.isSave" class="ml-2" size="sm" color="success" shape="pill" variant="outline"
                   @click="onSave">
            <span class="font-weight-bold pr-1"><CIcon name="cil-save"/> {{ $t('save') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isSend" class="ml-2" size="sm" color="info" shape="pill" variant="outline"
                   @click="onSend">
            <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/> {{ $t('send') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isUnSend" class="ml-2" size="sm" color="danger" shape="pill" variant="outline"
                   @click="onUnSend">
            <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/>  {{ $t('unsend') }} </span>
          </CButton>
          <CButton v-if="buttomControl.isRejected" class="ml-2" size="sm" color="dark" shape="pill" variant="outline"
                   @click="onRejected">
            <span class="font-weight-bold pr-1"><CIcon name="cil-loop-circular"/> {{ $t('reject') }} </span>
          </CButton>
        </CCol>
      </CRow>
    </div>

    <IDP v-if="this.isIdp"  :options="option"/>


  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import FilterOption from "@/projects/views/E-Performances/Estimate/components/FilterOption";
import Activitys from "@/projects/views/E-Performances/Estimate/components/Activitys";
import Cometencys from "@/projects/views/E-Performances/Estimate/components/Cometencys";
import Profile from "@/projects/views/E-Performances/Estimate/components/Profile";
import CometencyParent from "@/projects/views/E-Performances/Estimate/components/CometencyParent";
import IDP from "@/projects/views/E-Performances/Estimate/components/IDP";

export default {
  name: 'EDashborad',
  components: {IDP, CometencyParent, Profile, Cometencys, Activitys, FilterOption},
  props: {
    caption: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {

      tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],


      mapping: {
        type: "",
        item: {}
      },
      dialog: true,
      option: {
        organization: "66cbe802a41ed9362a8579fa",
        agency: "00000000000000000000000",
        year: new Date().getFullYear() + 542,
      },

      item: [{
        title: this.$t('assessment'),
        type: 0,
        fields: [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
          {key: "position", label: this.$t('department')},
          {key: "info", label: this.$t('fullname')},
          // {key:"status", label:"Gap",  _style: 'width:80px; text-align: center'},
          {key: "status", label: this.$t('status')},
          {key: "action", label: "#", _style: 'width:100px; text-align: center'},
          // {key:"action2", label: "ผล",  _style: 'width:100px; text-align: center'},

        ],
        isTimeline : true,
        historys: []
      }, {
        title: this.$t('subordinate'),
        type: 1,
        fields: [
          {key: "index", label: "#", _style: 'width:50px; text-align: center'},
          {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
          // {key:"year", label:"Year",  _style: 'width:100px;'},
          // {key:"position", label:"สังกัด"},
          {key: "position", label: this.$t('department')},
          {key: "info", label: this.$t('fullname')},
          {key: "status", label: this.$t('status')},
          {key: "action", label: "#", _style: 'width:100px; text-align: center'}
        ],
        isTimeline : false,
        historys: []
      }],


      profile: {},
      competency: [],
      type: 0,
      _id: null,


      isAssessment: false,
      objs: {},

      buttomControl: {
        isSave: false,
        isSend: false,
        isUnSend: false,
        isRejected: true
      },

      isIdp:false
    }


  },

  mounted() {
    this.onInit()
  },

  created() {

  },
  beforeDestroy() {

  },

  methods: {
    onClearData() {

    },
    onOptionChange(e) {
      this.isAssessment = false;
      this.option = e;
      this.onLoad();
    },
    //
    onInit() {
      var data = {};
      this.$store.dispatch("assessment/config", data)

      var data = {};
      this.$store.dispatch("personal/config", data)

      this.onLoad();
    },

    onLoad() {

      var body = {};
      body.yourself = true;
      body.organization = this.option.organization;
      body.year = parseInt(this.option.year);
      this.$store.dispatch("estimate/config", body)


      var body = {};
      body.yourself = false;
      body.organization = this.option.organization;
      body.year = parseInt(this.option.year);
      this.$store.dispatch("estimate/config", body)

    },

    yourself(item) {
      this.isAssessment = false;
      this.isIdp = false;

      if(item.isIDP === true){

        var body = {};
        body.organization = this.option.organization;
        body.year = parseInt(this.option.year);
        body.accounts = item.value.accounts._id;

        this.$store.dispatch("idp/init", body)

      }else{
        this.objs = item.value;
        this.objs.type = item.type;
        //
        if (item.type === 1) {
          this.objs.status = this.findObjectByIdInArray(this.objs.structure, this.$store.getters['personal/profile']._id).status
        } else {

        }
        this.onCheckState();
        this.isAssessment = true;
      }

    },


    // change status

    onClear() {
    },
    async onRejected() {
      var data = {};
      data.status = 3;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.objs.accounts._id;
      data.type = this.objs.type;

      await this.$store.dispatch("estimate/create", data)
      this.onLoad()

      this.buttomControl.isSave = true;
      this.buttomControl.isSend = false;
      this.buttomControl.isUnSend = false;
    },
    async onUnSend() {
      var data = {};
      data.status = 2;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.objs.accounts._id;
      data.type = this.objs.type;

      await this.$store.dispatch("estimate/create", data)
      this.onLoad()

      this.buttomControl.isSave = true;
      this.buttomControl.isSend = true;
      this.buttomControl.isUnSend = false;
    },
    async onSave() {
      var data = {};
      data.status = 0;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.objs.accounts._id;
      data.type = this.objs.type;
      if (data.type == 1) {
        data.item = this.findObjectByIdInArray(this.objs.structure, this.$store.getters['personal/profile']._id).item
      } else {
        data.item = this.objs.item
      }
      delete data.item[0].points
      delete data.item[0].datasets

      await this.$store.dispatch("estimate/create", data)
      this.onLoad()
      this.buttomControl.isSave = true;
      this.buttomControl.isSend = true;
      this.buttomControl.isUnSend = false;
      if (this.objs.type == 1) {
        this.buttomControl.isRejected = true;
      } else {
        this.buttomControl.isRejected = false;
      }
    },
    async onSend() {

      var data = {};
      data.status = 1;
      data._id = this.objs._id;
      data.organization = this.option.organization;
      data.year = this.option.year;

      data.accounts = this.objs.accounts._id;
      data.type = this.objs.type;
      if (data.type == 1) {
        data.item = this.findObjectByIdInArray(this.objs.structure, this.$store.getters['personal/profile']._id).item
      } else {
        data.item = this.objs.item
      }
      delete data.item[0].points
      delete data.item[0].datasets

      await this.$store.dispatch("estimate/create", data)
      this.onLoad()
      this.buttomControl.isSave = false;
      this.buttomControl.isSend = false;
      this.buttomControl.isUnSend = true;
    },

    findObjectByIdInArray(dataArray, targetId) {
      for (let obj of dataArray) {

        // ค้นหา _id ใน accounts
        if (obj.accounts && obj.accounts._id === targetId) {
          return obj;
        }
        // ค้นหา _id ใน children.accounts
        if (obj.children && obj.children.accounts && obj.children.accounts._id === targetId) {
          return obj.children;
        }

        // // ค้นหา _id ใน children.accounts
        if (obj.children.children && obj.children.children.accounts && obj.children.children.accounts._id === targetId) {
          return obj.children.children;
        }
      }
      // ถ้าไม่เจอให้ return null
      return null;
    },
    // end change status


    //
    onCheckState() {
      this.buttomControl.isSave = false;
      this.buttomControl.isSend = false;
      this.buttomControl.isUnSend = false;
      this.buttomControl.isRejected = false;


      if (this.objs.status[this.objs.status.length - 1].state._id.toString() == "6723709ab9a2030e40d1b884") {
        this.buttomControl.isSave = true;
      }

      if (this.objs.status[this.objs.status.length - 1].state._id.toString() == "654851a37ab25be71bbeeed6") {
        this.buttomControl.isSave = true;
      }
      // สามารถทำการ บันทึกได้

      if (this.objs.status[this.objs.status.length - 1].state._id.toString() == "654851dbe41b7f46025977f6") {
        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
      }
      // สามารถทำการ ส่งได้
      if (this.objs.status[this.objs.status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
        this.buttomControl.isUnSend = true;
        if (this.objs.structure[0].status.length > 1 && this.objs.type == 0) {
          this.buttomControl.isUnSend = false;
        } else {
          this.buttomControl.isUnSend = true;
        }
        if (this.objs.structure[0].status.length > 1) {
          this.buttomControl.isUnSend = false;
        }
      }


      if (this.objs.status[this.objs.status.length - 1].state._id.toString() == "670f777373effdb76e17954d") {
        this.buttomControl.isSave = true;
        this.buttomControl.isSend = true;
      }

      if (this.objs.type == 1) {
        this.buttomControl.isRejected = true;
        this.buttomControl.isUnSend = true;
      }
      // เปรียบเทียบ

      // ยอมรับ

      // ไม่ยอมรับ

    },

    //

    findAccountById(id, data) {
      // ฟังก์ชันค้นหาในแต่ละชั้นของข้อมูล
      function searchAccounts(obj) {
        if (obj._id === id) {
          return obj;
        }
        if (obj.accounts && typeof obj.accounts === 'object') {
          // ค้นหาใน accounts
          const result = searchAccounts(obj.accounts);
          if (result) return result;
        }
        if (Array.isArray(obj)) {
          // ค้นหาในอาร์เรย์
          for (const item of obj) {
            const result = searchAccounts(item);
            if (result) return result;
          }
        }
        return null;
      }

      // เริ่มค้นหาจากข้อมูลที่ให้มา
      return searchAccounts(data);
    },
    onCreatetChartPoint(objs) {
      var chart = [];
      for (var k = 0; k < objs.length; k++) {
        var level = objs[k].levels
        var point = 0;
        for (var l = 0; l < level.length; l++) {
          var checked = level[l].item.filter(item => {
            return (item.checked == false)
          })
          if (checked.length == 0) {
            point = point + 1
          } else {
            break;
          }
        }
        chart.push(point)

      }
      return chart;
    },
    onSetData(value) {
      for (var i = 0; i < value.length; i++) {
        //core
        var item = value[i].item
        var datasets = []
        var point = []

        var cc = item[0].item
        var objs = this.onCreatetChartPoint(cc)
        var points = {};
        points.accounts = value[i].accounts.accounts
        points.objs = objs
        point.push(points)


        var objData = {
          label: 'Self',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(6,29,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        var structure = value[i].structure[0];
        var cc = structure.item[0].item
        var objs = this.onCreatetChartPoint(cc)
        var points = {};
        points.accounts = value[i].structure[0].accounts.accounts
        points.objs = objs
        point.push(points)

        var objData = {
          label: 'Assessor 1',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(229,6,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        if (structure.children.item.length > 0) {
          var cc = structure.children.item[0].item
          var objs = this.onCreatetChartPoint(cc)
          var points = {};
          points.accounts = structure.children.accounts.accounts
          points.objs = objs
          point.push(points)
          var objData = {
            label: 'Assessor 2',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgb(0,255,108)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            tooltipLabelColor: 'rgba(179,181,198,1)',
            data: objs
          };
          datasets.push(objData)
        }

        item[0].datasets = datasets
        item[0].points = point
      }
      return value
    },


  },


  computed: {
    ...mapGetters({
      objsLang: "setting/lang",
      userId: "auth/userId",
      // objsItem : "assessment/assessment",
      // objsProfile : "personal/profile",

      objsYourself: "estimate/yourself",
      objsHistory: "estimate/history",
      isReload: "estimate/isReload",



      objsIdp: "idp/idp"



    }),
  },

  watch: {
    objsLang(value) {

      this.item[0].title = this.$t('assessments');
      this.item[0].fields = [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
        {key: "position", label: this.$t('department')},
        {key: "info", label: this.$t('fullname')},
        // {key:"status", label:"Gap",  _style: 'width:80px; text-align: center'},
        {key: "status", label: this.$t('status')},
        {key: "action", label: "#", _style: 'width:100px; text-align: center'},
        // {key:"action2", label: "ผล",  _style: 'width:100px; text-align: center'},

      ];

      this.item[1].title = this.$t('subordinate');
      this.item[1].fields = [
        {key: "index", label: "#", _style: 'width:50px; text-align: center'},
        {key: "code", label: this.$t('staffID'), _style: 'width:100px;'},
        // {key:"year", label:"Year",  _style: 'width:100px;'},
        // {key:"position", label:"สังกัด"},
        {key: "position", label: this.$t('department')},
        {key: "info", label: this.$t('fullname')},
        {key: "status", label: this.$t('status')},
        {key: "action", label: "#", _style: 'width:100px; text-align: center'}
      ];

      //   this.onLoad()
      //   this.$store.commit("estimate/isReload", false)
    },
    isReload(value) {
      if (value == true) {
        this.onLoad()
        this.$store.commit("estimate/isReload", false)
      }
    },
    objsProfile(value) {
      this.profile = value;
    },

    objsItem(value) {
      // delete value._id;
      this.competency = value.item;
    },

    objsYourself(value) {
      value = this.onSetData(value)

      for (var i = 0; i < value.length; i++) {
        //core
        var item = value[i].item
        var datasets = []

        var cc = item[0].item
        var objs = this.onCreatetChartPoint(cc)

        var objData = {
          label: 'Self',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(6,29,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        var structure = value[i].structure[0];
        var cc = structure.item[0].item
        var objs = this.onCreatetChartPoint(cc)

        var objData = {
          label: 'Assessor 1',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgb(229,6,245)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          tooltipLabelColor: 'rgba(179,181,198,1)',
          data: objs
        };
        datasets.push(objData)

        if (structure.children.item > 0) {
          var cc = structure.children.item[0].item
          var objs = this.onCreatetChartPoint(cc)
          var objData = {
            label: 'Assessor 2',
            backgroundColor: 'rgba(179,181,198,0.2)',
            borderColor: 'rgb(0,255,108)',
            pointBackgroundColor: 'rgba(179,181,198,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(179,181,198,1)',
            tooltipLabelColor: 'rgba(179,181,198,1)',
            data: objs
          };
          datasets.push(objData)
        }

        item[0].datasets = datasets
      }
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        objs.type = 0
        objs.year = item.year
        try {
          objs.code = item.accounts.accounts.code
        } catch (e) {

        }
        objs.info = item.accounts.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value + " " + item.accounts.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value + " " + item.accounts.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        objs.position = item.position.agency.title
        objs.disable = true
        try {
          // level 1
          if (item.status[item.status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
            objs.status = item.structure[0].status[item.structure[0].status.length - 1].state.title
            objs.assessor = item.structure[0].accounts.accounts.userinfo.prefix.filter(obj => {
              return (obj.key == lang)
            })[0].value + " " + item.structure[0].accounts.accounts.userinfo.firstName.filter(obj => {
              return (obj.key == lang)
            })[0].value + " " + item.structure[0].accounts.accounts.userinfo.lastName.filter(obj => {
              return (obj.key == lang)
            })[0].value
            if (item.structure[0].status[item.structure[0].status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
              try {
                objs.status = item.structure[0].children.status[item.structure[0].children.status.length - 1].state.title
                objs.assessor = item.structure[0].children.accounts.accounts.userinfo.prefix.filter(obj => {
                  return (obj.key == lang)
                })[0].value + " " + item.structure[0].children.accounts.accounts.userinfo.firstName.filter(obj => {
                  return (obj.key == lang)
                })[0].value + " " + item.structure[0].children.accounts.accounts.userinfo.lastName.filter(obj => {
                  return (obj.key == lang)
                })[0].value

                if (item.structure[0].children.status[item.structure[0].children.status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
                  objs.status = [
                    {
                      "key": "en",
                      "value": "Completed",
                      "_id": "654851a37ab25be71bbeeed7"
                    },
                    {
                      "key": "th",
                      "value": "เสร็จสิ้น"
                    }
                  ]
                }
              } catch (e) {
                objs.status = [
                  {
                    "key": "en",
                    "value": "Completed",
                    "_id": "654851a37ab25be71bbeeed7"
                  },
                  {
                    "key": "th",
                    "value": "เสร็จสิ้น"
                  }
                ]
              }
            } else {
              objs.status = item.structure[0].status[item.structure[0].status.length - 1].state.title
              objs.assessor = item.structure[0].accounts.accounts.userinfo.prefix.filter(obj => {
                return (obj.key == lang)
              })[0].value + " " + item.structure[0].accounts.accounts.userinfo.firstName.filter(obj => {
                return (obj.key == lang)
              })[0].value + " " + item.structure[0].accounts.accounts.userinfo.lastName.filter(obj => {
                return (obj.key == lang)
              })[0].value
            }

          } else {
            objs.status = item.status[item.status.length - 1].state.title
            objs.assessor = " "
          }
        } catch (e) {
          // objs.status = item.status[item.status.length-1].state.title.filter(title => {
          //   if (title.key == "en") {
          //     return title
          //   }
          // })[0].value
        }


        objs.value = item;
        // objs.historys = []

        items.push(objs)
      })
      this.item[0].historys = items;
    },
    objsHistory(value) {
      value = this.onSetData(value)
      // this.historys = [];
      var lang = this.$store.getters['setting/lang']
      var items = [];
      value.filter(item => {
        var objs = {};
        objs.type = 1
        objs.year = item.year
        try {
          objs.code = item.accounts.accounts.code
        } catch (e) {

        }

        objs.info = item.accounts.accounts.userinfo.prefix.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value + " " + item.accounts.accounts.userinfo.firstName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value + " " + item.accounts.accounts.userinfo.lastName.filter(title => {
          if (title.key == lang) {
            return title
          }
        })[0].value;
        objs.position = item.position.agency.title


        try {
          // level 1
          if (item.status[item.status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {

            objs.status = item.structure[0].status[item.structure[0].status.length - 1].state.title
            objs.assessor = item.structure[0].accounts.accounts.userinfo.prefix.filter(obj => {
              return (obj.key == lang)
            })[0].value + " " + item.structure[0].accounts.accounts.userinfo.firstName.filter(obj => {
              return (obj.key == lang)
            })[0].value + " " + item.structure[0].accounts.accounts.userinfo.lastName.filter(obj => {
              return (obj.key == lang)
            })[0].value

            if (item.structure[0].status[item.structure[0].status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
              try {
                objs.disable = true;//item.structure[0].children.accounts._id.toString() == this.$store.getters['personal/profile']._id

                objs.status = item.structure[0].children.status[item.structure[0].children.status.length - 1].state.title;
                objs.assessor = item.structure[0].children.accounts.accounts.userinfo.prefix.filter(obj => {
                  return (obj.key == lang)
                })[0].value + " " + item.structure[0].children.accounts.accounts.userinfo.firstName.filter(obj => {
                  return (obj.key == lang)
                })[0].value + " " + item.structure[0].children.accounts.accounts.userinfo.lastName.filter(obj => {
                  return (obj.key == lang)
                })[0].value;


                if (item.structure[0].children.status[item.structure[0].children.status.length - 1].state._id.toString() == "654851ece41b7f46025977fa") {
                  objs.disable = true
                  objs.status = [
                    {
                      "key": "en",
                      "value": "Completed",
                      "_id": "654851a37ab25be71bbeeed7"
                    },
                    {
                      "key": "th",
                      "value": "เสร็จสิ้น"
                    }
                  ]

                }
              } catch (e) {
                objs.disable = true
                objs.status = [
                  {
                    "key": "en",
                    "value": "Completed",
                    "_id": "654851a37ab25be71bbeeed7"
                  },
                  {
                    "key": "th",
                    "value": "เสร็จสิ้น"
                  }
                ]

              }
            } else {
              objs.disable = item.structure[0].accounts._id.toString() == this.$store.getters['personal/profile']._id
              objs.status = item.structure[0].status[item.structure[0].status.length - 1].state.title
              objs.assessor = item.structure[0].accounts.accounts.userinfo.prefix.filter(obj => {
                return (obj.key == lang)
              })[0].value + " " + item.structure[0].accounts.accounts.userinfo.firstName.filter(obj => {
                return (obj.key == lang)
              })[0].value + " " + item.structure[0].accounts.accounts.userinfo.lastName.filter(obj => {
                return (obj.key == lang)
              })[0].value
            }

          } else {
            objs.status = item.status[item.status.length - 1].state.title
            objs.assessor = ""
          }


        } catch (e) {


        }


        objs.value = item;
        // objs.historys = []

        items.push(objs)
      })
      this.item[1].historys = items;
    },


    objsIdp(value){
      this.isIdp = true;
    }
  }


}
</script>
<style>
</style>

